import { Pipe, PipeTransform } from '@angular/core';
import { slugKeepUnderscore } from '@core/utils/slug.config';
import type { Options } from 'slug';

@Pipe({
  name: 'slug',
})
export class SlugPipe implements PipeTransform {
  transform(value: string, options?: Partial<Options>): unknown {
    return slugKeepUnderscore(value, options);
  }
}
